import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Across-service to manage the visibility of components in the application.
 */
@Injectable({ providedIn: 'root' })
export class ComponentVisibilityService {
  private visibilityMap = new Map<string, BehaviorSubject<boolean>>();

  /**
   * Returns a BehaviorSubject that tracks the visibility of a component by its ID.
   * The BehaviorSubject emits true if the component is visible, and false if it is hidden.
   * The default value is true (visible).
   */
  getOrCreateVisibility(id: string): BehaviorSubject<boolean> {
    if (!this.visibilityMap.has(id)) {
      this.visibilityMap.set(id, new BehaviorSubject<boolean>(true));
    }

    return this.visibilityMap.get(id);
  }

  setVisibility(id: string, visible: boolean): void {
    this.visibilityMap.get(id)?.next(visible);
  }
}
